import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const CopyCtx = createContext(() => "");

export const CopyProvider = ({ children }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/site-content").then((r) => setData(r.data)).catch(() => setData({}));
  }, []);
  if (!data) return <div className="min-h-screen" aria-busy="true" data-testid="site-copy-loading" />;
  const t = (k) => data[k] ?? "";
  return <CopyCtx.Provider value={t}>{children}</CopyCtx.Provider>;
};

export const useCopy = () => useContext(CopyCtx);

export const sortByOrder = (items, t) => [...items].sort((a, b) => (Number(t(`${a}.order`)) || 99) - (Number(t(`${b}.order`)) || 99));
